export default __webpack_public_path__ + "static/media/calendarGrey.753e374a.svg";